import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20227b7b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "material-table" }
const _hoisted_2 = { class: "material-table__actions mb15" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("加入待选 >>")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_table_wrapper = _resolveComponent("table-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: _ctx.add
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_table_wrapper, {
      "row-key": "id",
      size: "small",
      bordered: true,
      loading: _ctx.loading,
      "data-source": _ctx.records,
      columns: _ctx.columns,
      scroll: { x: true },
      checkboxConfig: {checkMethod:({row})=>{
        return row.cumulativeSignCount!=row.currentOrderCount
      }},
      onOnSelectionChange: _ctx.onSelectionChange,
      tableHeight: _ctx.tableHeight
    }, {
      index: _withCtx(({ index }) => [
        _createTextVNode(_toDisplayString(index + 1), 1)
      ]),
      taxPrice: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_ctx.$filters.formatMoney(record.taxPrice)), 1)
      ]),
      _: 1
    }, 8, ["loading", "data-source", "columns", "checkboxConfig", "onOnSelectionChange", "tableHeight"])
  ]))
}